!(function () {
    "use strict";
    var e = {
            4105: function (e, t, n) {
                n.d(t, {
                    St: function () {
                        return i;
                    },
                    gp: function () {
                        return s;
                    },
                    hO: function () {
                        return o;
                    },
                    zx: function () {
                        return a;
                    },
                });
                const o = function () {
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    const t = window.innerWidth - document.body.offsetWidth,
                        n = document.getElementById("nav-wrapper");
                    e
                        ? (document.body.classList.add("no-scroll"), (document.body.style.paddingRight = t + "px"), (n.style.paddingRight = t + "px"))
                        : (document.body.classList.remove("no-scroll"), (document.body.style.paddingRight = "0px"), (n.style.paddingRight = "0px"));
                };
                let r = () => {};
                const c = (e) => {
                        "Escape" === e.key && (r(), window.removeEventListener("keydown", c));
                    },
                    s = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (r = t), e && window.addEventListener("keydown", c), e || window.removeEventListener("keydown", c);
                    };
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        ((e) => {
                            Math.easeInOutQuad = function (e, t, n, o) {
                                return (e /= o / 2) < 1 ? (n / 2) * e * e + t : (-n / 2) * (--e * (e - 2) - 1) + t;
                            };
                            const t = document.getElementById("grid-archive-header"),
                                n = document.getElementById("nav-wrapper");
                            let o = 0,
                                r = 0;
                            t && (o = t.offsetHeight + 50), n && (r = n.offsetHeight + 50);
                            const c = e.offsetTop - o - r,
                                s = window.scrollY,
                                d = c - s;
                            let i = 0;
                            const a = () => {
                                i += 5;
                                const e = Math.easeInOutQuad(i, s, d, 200);
                                window.scrollTo(0, e), i < 200 && setTimeout(a, 5);
                            };
                            a();
                        })(document.querySelector(t));
                    });
                });
                const d = {};
                function i(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                    const n = (function (e) {
                            return Array.from(
                                e.querySelectorAll('summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe')
                            );
                        })(e),
                        o = n[0],
                        r = n[n.length - 1];
                    a(),
                        (d.focusin = (t) => {
                            (t.target !== e && t.target !== r && t.target !== o) || document.addEventListener("keydown", d.keydown);
                        }),
                        (d.focusout = function () {
                            document.removeEventListener("keydown", d.keydown);
                        }),
                        (d.keydown = function (t) {
                            "TAB" === t.code.toUpperCase() && (t.target !== r || t.shiftKey || (t.preventDefault(), o.focus()), (t.target !== e && t.target !== o) || !t.shiftKey || (t.preventDefault(), r.focus()));
                        }),
                        document.addEventListener("focusout", d.focusout),
                        document.addEventListener("focusin", d.focusin),
                        t.focus();
                }
                function a(e) {
                    document.removeEventListener("focusin", d.focusin), document.removeEventListener("focusout", d.focusout), document.removeEventListener("keydown", d.keydown), e && e.focus();
                }
            },
        },
        t = {};
    function n(o) {
        var r = t[o];
        if (void 0 !== r) return r.exports;
        var c = (t[o] = { exports: {} });
        return e[o](c, c.exports, n), c.exports;
    }
    (n.d = function (e, t) {
        for (var o in t) n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, { enumerable: !0, get: t[o] });
    }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (function () {
            var e = n(4105);
            class t extends HTMLElement {
                constructor() {
                    super(), this.connect();
                }
                connect() {
                    const t = this,
                        n = t.querySelector(".mini-cart__sidebar"),
                        o = document.getElementById("overlay"),
                        r = document.querySelectorAll("button[name='cart-open']"),
                        c = document.querySelector("body"),
                        s = () => {
                            t.classList.remove("open"),
                                window.setTimeout(() => {
                                    o.classList.remove("open");
                                }, 1),
                                c.style.removeProperty("overflow"),
                                (0, e.hO)(!1);
                        };
                    r &&
                        r.forEach((r) => {
                            r.addEventListener("click", () => {
                                t.classList.add("open"),
                                    window.setTimeout(() => {
                                        o.classList.add("open", "overlay--all");
                                    }, 1),
                                    document.body.classList.add("active", "minicart"),
                                    (0, e.gp)(!0, s),
                                    (0, e.hO)(!0),
                                    t.focus(),
                                    (0, e.St)(t, n);
                            });
                        }),
                        document.getElementById("cart-close").addEventListener("click", () => {
                            t.classList.remove("open"),
                                window.setTimeout(() => {
                                    o.classList.remove("open", "overlay--all");
                                }, 1),
                                document.body.classList.remove("active", "minicart"),
                                (0, e.hO)(!1),
                                (0, e.zx)(t);
                        }),
                        o.addEventListener("click", () => {
                            t.classList.remove("open"),
                                window.setTimeout(() => {
                                    o.classList.remove("open", "overlay--all");
                                }, 1),
                                document.body.classList.remove("active", "minicart"),
                                (0, e.hO)(!1),
                                (0, e.zx)(t);
                        });
                }
                attachOverlay() {
                    document.getElementById("overlay").insertAdjacentElement("beforebegin", this);
                }
            }
            if (!customElements.get("drawer-component")) {
                customElements.define("drawer-component", t);
                const e = document.querySelector("drawer-component");
                e && e.attachOverlay();
            }
        })();
})();
